import React, { useState } from "react";
import api from "../../services/api";

const FIELD =
  "mb-3 w-full rounded-lg border border-stone-300 bg-stone-100 p-3 text-stone-500 placeholder:text-stone-400 dark:border-slate-700 dark:bg-slate-800 dark:text-white";
const LABEL = "text-sm font-medium text-stone-700 dark:text-slate-300";

/**
 * The single poids form, shared by the dialog on desktop and the /poids route on
 * mobile.
 */
function WeightForm({ calfID, onDone, onCancel }) {
  const [date, setDate] = useState(new Date().toISOString().substring(0, 10));
  const [weight, setWeight] = useState("");
  const [isSaving, setSaving] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    setSaving(true);

    api
      .post("/weight", {
        date: date,
        // farmers type a comma, the API wants a dot
        weight: parseFloat(String(weight).replace(",", ".")),
        fk_calf: calfID,
      })
      .then(() => onDone())
      .catch((error) => {
        console.error("There was an error saving the weight!", error);
        setSaving(false);
      });
  };

  return (
    <form onSubmit={handleSubmit} className="flex w-full flex-col">
      <label htmlFor="weight_input" className={LABEL}>
        Poids (kg)
      </label>
      <input
        className={FIELD}
        type="text"
        inputMode="decimal"
        value={weight}
        onChange={(e) => setWeight(e.target.value)}
        placeholder="Poids en kilos"
        name="weight_input"
      />

      <label htmlFor="weight_date_input" className={LABEL}>
        Date de la pesée
      </label>
      <input
        className={FIELD}
        type="date"
        value={date}
        onChange={(e) => setDate(e.target.value)}
        name="weight_date_input"
      />

      <button
        type="submit"
        disabled={isSaving}
        className="my-3 w-full rounded-lg bg-amber-400 p-3 font-medium text-white disabled:opacity-50 dark:bg-amber-600"
      >
        Ajouter
      </button>
      <button
        type="button"
        onClick={onCancel}
        className="mb-3 w-full rounded-lg border border-stone-300 p-3 text-sm text-stone-500 hover:text-amber-500 dark:border-slate-700 dark:text-slate-300"
      >
        Annuler
      </button>
    </form>
  );
}

export default WeightForm;
